// ENG-1865: moved unchanged from operatorSign.jsx so the sign-all page draws the signature exactly as the single page does.
export async function stampSignatureImage(pdfDoc, signImageUrl, signatureFields) {
  const pages = pdfDoc.getPages();
  const imageResponse = await fetch(`${signImageUrl}?t=${Date.now()}`, {
    mode: "cors",
    cache: "no-store",
  });
  const imageArrayBuffer = await imageResponse.arrayBuffer();
  const contentType = imageResponse.headers.get("Content-Type");

  let image;
  if (contentType === "image/png") {
    image = await pdfDoc.embedPng(imageArrayBuffer);
  } else if (contentType === "image/jpeg") {
    image = await pdfDoc.embedJpg(imageArrayBuffer);
  } else {
    throw new Error("Unsupported image type");
  }
  signatureFields.forEach(
    ({ page_number, position_x, position_y, width, height }) => {
      const pageIndex = page_number - 1;
      if (pageIndex >= 0 && pageIndex < pages.length) {
        const page = pages[pageIndex];
        const { height: pageHeight } = page.getSize();

        page.drawImage(image, {
          x: position_x + 20,
          y: pageHeight - position_y - 70,
          width: 200,
          height: 60,
        });
      }
    }
  );
}
